import {
  Breadcrumb,
  Breadcrumbs as BreadcrumbsComponent,
} from '../../Breadcrumbs'
import { FileDirectoryBreadcrumb, FileDirectoryBreadcrumbs } from '../../File'
import { Container } from '../Container'

import {
  BREADCRUMBS_RELOAD_INTERVAL,
  BreadcrumbsCollapsed,
} from './BreadcrumbsCollapsed'

function Breadcrumbs() {
  const items = [
    { id: '1', title: 'Head', to: '/' },
    { id: '2', title: 'Breadcrumb 1', to: '/' },
    { id: '3', title: 'Breadcrumb 2', to: '/' },
    { id: '4', title: 'Breadcrumb active' },
  ]

  return (
    <>
      <Container label='Breadcrumb last item'>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Breadcrumb
            active
            count={111}
            option={{ id: '1', title: 'Breadcrumb', to: '/' }}
          />
        </div>
      </Container>
      <Container label='Breadcrumb item'>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Breadcrumb head option={{ id: '1', title: 'Breadcrumb', to: '/' }} />
        </div>
      </Container>
      <Container label='Breadcrumb head item'>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Breadcrumb
            head
            info='info'
            option={{ id: '1', title: 'Breadcrumb', to: '/' }}
          />
        </div>
      </Container>
      <Container label='Breadcrumb long name in small box'>
        <div
          style={{
            display: 'flex',
            maxWidth: '20%',
          }}
        >
          <Breadcrumb
            checked
            option={{
              id: '1',
              info: 'info',
              title: 'Breadcrumb long name',
            }}
          />
        </div>
      </Container>
      <Container label='Skeleton'>
        <div style={{ width: '100%' }}>
          <BreadcrumbsComponent isLoading count={100} items={items} />
        </div>
      </Container>
      <Container label='Breadcrumbs full size'>
        <div style={{ width: '100%' }}>
          <BreadcrumbsComponent count={100} items={items} />
        </div>
      </Container>
      <Container label='Breadcrumbs container size 50%'>
        <div style={{ width: '50%' }}>
          <BreadcrumbsComponent count={333} items={items} />
        </div>
      </Container>
      <Container
        label={`Breadcrumbs with items reloaded every ${BREADCRUMBS_RELOAD_INTERVAL}ms`}
      >
        <BreadcrumbsCollapsed />
      </Container>
      <Container label='Breadcrumbs 35%'>
        <div style={{ width: '35%' }}>
          <BreadcrumbsComponent
            count={100}
            items={[
              { id: '1', title: 'Breadcrumb 1', to: '/' },
              { id: '2', title: 'Breadcrumb 2' },
            ]}
          />
        </div>
      </Container>
      <Container label='Breadcrumbs full size'>
        <div style={{ width: '100%' }}>
          <BreadcrumbsComponent
            count={100}
            items={[
              { id: '1', title: 'Breadcrumb 1', to: '/' },
              { id: '2', info: 'some info', title: 'Breadcrumb 2', to: '/' },
            ]}
          />
        </div>
      </Container>
      <Container label='Breadcrumbs full size'>
        <div style={{ width: '100%' }}>
          <BreadcrumbsComponent
            count={100}
            items={[
              {
                id: '1',
                info: 'some info',
                title: 'Breadcrumb single',
                to: '/',
              },
            ]}
          />
        </div>
      </Container>
      <Container label='File Directory Breadcrumb long name in small box'>
        <div
          style={{
            display: 'flex',
            maxWidth: '20%',
          }}
        >
          <FileDirectoryBreadcrumb
            checked
            option={{
              id: '1',
              title: 'Breadcrumb long name',
            }}
          />
        </div>
      </Container>
      <Container label='File Directory Breadcrumbs in small box'>
        <div style={{ width: '35%' }}>
          <FileDirectoryBreadcrumbs
            items={[
              { id: '1', title: 'Breadcrumb 1' },
              { id: '2', title: 'Breadcrumb 2' },
              { id: '3', title: 'Breadcrumb 3' },
              { id: '4', title: 'Breadcrumb 4' },
            ]}
          />
        </div>
      </Container>
    </>
  )
}

export default Breadcrumbs
